export default function forceSslReducer
    (state = { error:'', success:'', processing:false}, action)
{
    switch (action.type) {
        case 'FORCE_SSL_SUCCESS':
            return {...state, ...{success: action.success}};

        case 'FORCE_SSL_ERROR':
            return {...state, ...{error: action.error}};

        case 'FORCE_SSL_PROCESSING':
            return {...state, ...{processing: action.processing}};

        default: return state;
    }
}